import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL cart -------------------- */
export const AllCartCollactionThunk = createAsyncThunk(
  "cart/AllCartCollactionThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/cart-total`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch cart");
    }
  }
);

/* -------------------- GET SINGLE cart -------------------- */
export const GetSingleCartCollactionThunk = createAsyncThunk(
  "cart/GetSingleCartCollactionThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/cart-item-view?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch cart details"
      );
    }
  }
);
/* -------------------- ALL Wishlist  -------------------- */
export const AllWishlistCollactionThunk = createAsyncThunk(
  "wishlist/AllWishlistCollactionThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/wish-total`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch cart");
    }
  }
);

/* -------------------- GET SINGLE Wishlist -------------------- */
export const GetSingleWishlistCollactionThunk = createAsyncThunk(
  "wishlist/GetSingleWishlistCollactionThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/wish-item-view?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch cart details"
      );
    }
  }
);


/* -------------------- ALL cart -------------------- */
export const AllTotalsHomepageThunk = createAsyncThunk(
  "cart/AllTotalsHomepageThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin-wigits`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch cart");
    }
  }
);
